"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initHotjar = exports.identifyHotjar = exports.getHotjarId = void 0;
const getHotjarId = siteId => {
  switch (siteId) {
    case 1:
      return 1831623;
    // france
    case 2:
      return 1959888;
    // germany
    case 3:
      return 1703421;
    // spain
    case 4:
      return 1959891;
    // italy
    case 7:
      return 1959889;
    // austria
    case 66:
      return 1816844;
    // privalia es
    case 69:
      return 1826509;
    // privalia it
    case 70:
      return 2467201;
    case 71:
      return 2513087;
    case 73:
      return 2467199;
    case 76:
      return 2467200;
    default:
      return 153440;
  }
};
exports.getHotjarId = getHotjarId;
const VERSION = 6;
const URL = '//static.hotjar.com/c/hotjar-';
const QUERY = '.js?sv=';
const getScriptPath = hotjarId => `${URL}${hotjarId}${QUERY}${VERSION}`;
const throwAsyncError = message => {
  const error = new Error(message);
  error.name = `Hotjar ${error.name}`;
  return Promise.reject(error);
};
const seHotjarbase = (hotjarId, scriptPath) => {
  window.hj = window.hj || ((...args) => {
    ;
    (window.hj.q = window.hj.q || []).push(args);
  });
  window._hjSettings = {
    hjid: hotjarId,
    hjsv: VERSION
  };
  window._scriptPath = scriptPath;
};
const initHotjar = (hotjarId, onLoad) => {
  const scriptPath = getScriptPath(hotjarId);
  seHotjarbase(hotjarId, scriptPath);
  if (onLoad) onLoad();
  if (!document.querySelector(`script[src*="${scriptPath}"]`)) {
    const script = document.createElement('script');
    script.src = scriptPath;
    document.head.appendChild(script);
  }
};
exports.initHotjar = initHotjar;
const identifyHotjar = (memberId, data = {}) => {
  if (!window.hj) {
    throwAsyncError('missing window.hj');
    return;
  }
  if (!memberId) {
    throwAsyncError('missing memberId');
    return;
  }
  window.hj('identify', memberId, data);
};
exports.identifyHotjar = identifyHotjar;